import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, Button, Collapse, List, ListItem, ListItemText, makeStyles } from '@material-ui/core';
import Skeleton from '@material-ui/lab/esm/Skeleton';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import moment from 'moment';
import { history } from '../../helpers/history';
import Typography from '@material-ui/core/Typography';
import { checkPermissionUser } from '../../functions/permissions-functions';

const useStyles = makeStyles((theme) => ({
    listItems: {
        color: 'rgb(65, 65, 65)',
        fontSize: '0.875rem',
        fontFamily: 'Ubuntu',
    },
    submit: {
        margin: (3, 0, 2),
        fontWeight: 'bold',
        fontSize: '0.6rem',
        borderLeft: '3px solid rgba(255, 198, 0)',
        color: '#1a1919',
        backgroundColor: "#ffffff",
        width : "200px",
        fontFamily: 'Ubuntu',
        "&:hover": {
            backgroundColor: "#ffffff",
            borderLeft: '3px solid rgba(255, 198, 0)',
        }
    },
    textaccounts: {
        [theme.breakpoints.up('xs')]: {
            fontSize: '100%',
            fontFamily: 'Ubuntu Ligth 300',
            fontWeight: 'bold',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '100%',
            fontFamily: 'Ubuntu Ligth 300',
            fontWeight: 'bold',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '100%',
            fontFamily: 'Ubuntu Ligth 300',
            fontWeight: 'bold',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '100%',
            fontFamily: 'Ubuntu Ligth 300',
            fontWeight: 'bold',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '100%',
            fontFamily: 'Ubuntu Ligth 300',
            fontWeight: 'bold',
        }
    },
    logo: {
        [theme.breakpoints.up('xs')]: {
            width: `35px`,
        },
        [theme.breakpoints.up('sm')]: {
            width: `80%`,
        },
        [theme.breakpoints.up('md')]: {
            width: `80%`,
        },
        [theme.breakpoints.up('lg')]: {
            width: `80%`,
        },
        [theme.breakpoints.up('xl')]: {
            width: `80%`,
        },
      },
    icon: {
        [theme.breakpoints.up('xs')]: {
           minWidth: '56px'
        },
        [theme.breakpoints.up('sm')]: {
            width: `40%`,
        },
        [theme.breakpoints.up('md')]: {
            width: `24%`,
        },
        [theme.breakpoints.up('lg')]: {
            width: `24%`,
        },
        [theme.breakpoints.up('xl')]: {
            width: `24%`,
        },
    },
    iconviewhistorial : {
        [theme.breakpoints.up('xs')]: {
            width: `40%`,
        },
        [theme.breakpoints.up('sm')]: {
            width: `80%`,
        },
        [theme.breakpoints.up('md')]: {
            width: `80%`,
        },
        [theme.breakpoints.up('lg')]: {
            width: `80%`,
        },
        [theme.breakpoints.up('xl')]: {
            width: `80%`,
        },
    },
    stylenumberaccount : {
        color: '#1a1919',
        fontSize: '140%',
        fontFamily: 'Ubuntu',
    },
    stylesaldoaccount : {
        fontSize: '100%',
        fontFamily: 'Ubuntu',
    }
}));

const UserInfo = props => {
    const { balances, skeleton, deposits, credits, balancesjoint, userPermissions } = props
    
    const [openAccounts, setOpenAccounts] = useState(false)
    const [openAccountsJoint, setOpenAccountsJoint] = useState(false)
    const [openDeposits, setOpenDeposits] = useState(false)
    const [openCredits, setOpenCredits] = useState(false)
    
    const classes2 = useStyles()
      
    /* const renderCredits = () => {
        const { infoPayment } = credits
        if (infoPayment.length > 0 ) {
            const { aditionalPayment } = credits
            return  <div>
                        <b>{ `Consulta de Creditos` } </b><br/>
                        <b>{ `Operación: `}</b>{ `${infoPayment[0].Codigo} `}<br/>
                        <b>{ `Valor cancelar: `}</b>{ `$ ${aditionalPayment.ValorCancelar} `}<br/>
                        <b>{ `Valor total cuota: `}</b>{ `$ ${aditionalPayment.ValorTotalCuota} `}<br/>
                        <b>{ `Saldo Actual: `}</b>{ `$ ${aditionalPayment.SaldoActual} `}<br/>
                    </div>
        } else {
            return <Alert severity="info">El usuario no tiene creditos</Alert>
        }
    } */

    const renderDetailSavingsAccount = (saldo, codigo, estado, secuencial) => {
        return  <Typography className = {classes2.textaccounts}>
                    <b className = {classes2.stylenumberaccount}>{ `${codigo} `}</b>
                    <br />
                    <span className = {classes2.stylesaldoaccount}>{ `Saldo: `}{ <b>$ { `${parseFloat(saldo).toFixed(2)} `}</b>}</span>
                    <br />
                    <span className = {classes2.stylesaldoaccount}>{ `Estado: `}{ <b>{ `${estado} `}</b>}</span>
                    <br />
                    <br />
                    { (checkPermissionUser(userPermissions, 9)) && <Button variant="contained" onClick = {() => history.push(`/movements/${secuencial}`)}  className = { classes2.submit}>
                        Ver Movimientos
                    </Button>}
                </Typography>
        
    }

    const renderDetailFixedTermDeposits = (monto, numero, fechavencimiento, estado, secuencial) => {
        return  <Typography className = {classes2.textaccounts}>
                    <b>{ `Monto: `}</b>{ `$ ${parseFloat(monto).toFixed(2)} `}
                    <br />
                    <b>{ `Número: `}</b>{ `${numero} `}
                    <br />
                    <b>{ `Vencimiento: `}</b>{ `${moment(fechavencimiento).format('DD/MM/YYYY')} `}
                    <br />
                    <b>{ `Estado: `}</b>{ `${estado} `}
                    <br />
                    <br />
                    { (checkPermissionUser(userPermissions, 21)) && <Button variant="contained" onClick = {() => history.push(`/movements-deposits/${secuencial}`)} size = "small" className = { classes2.submit}>
                        Ver Movimientos
                    </Button> } 
                </Typography>
        
    }

    const renderDetailCredits = (saldo, codigo, estado, secuencial, DeudaInicial) => {
        return  <Typography className = {classes2.textaccounts}>
                    <b>{ `Deuda Inicial: `}</b>{ `$ ${DeudaInicial} `}
                    <br />
                    <b>{ `Saldo: `}</b>{ `$ ${parseFloat(saldo).toFixed(2)} `}
                    <br />
                    <b>{ `Número: `}</b>{ `${codigo} `}
                    <br />
                    <b>{ `Estado: `}</b>{ `${estado} `}
                    <br />
                    <br />
                    { (checkPermissionUser(userPermissions, 18)) && <Button variant="contained" onClick = {() => history.push(`/movements-credits/${secuencial}`)} size = "small" className = { classes2.submit}>
                        Ver Movimientos
                    </Button> }
                </Typography>
        
    }

    if (skeleton) {
        return  (
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12} lg = {12} sm = {12}>
                            <br/>
                            {<Skeleton variant="text" />}
                            <br/>
                            { <Skeleton variant="text" />}
                            <br/>
                            <Skeleton variant="text" />
                            <br/>
                            
                        </Grid>
                    </Grid>)

    } else {
        return (
                <Grid container spacing={1}>
                    <Grid item xs={12} md={12} lg = {12} sm = {12}>
                        <List
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                        >
                            
                            <ListItem button onClick={() => setOpenAccounts(!openAccounts)}
                                            style={{ borderLeft: '3px solid rgba(255, 198, 0)',
                                            
                                            color: '#009aa8'}}>
                                {/* {<ListItemIcon>
                                    <Icon>inbox</Icon>
                                </ListItemIcon>} */}
                                <ListItemText 
                                    primary={<Typography className = {classes2.textaccounts} align = "left">
                                                {"Cuenta de ahorro"}
                                            </Typography>} 
                                    
                                />
                                {openAccounts ? <ExpandLessIcon style={{ color: "rgba(255, 198, 0)" }}/> : <ExpandMoreIcon style={{ color: "rgba(255, 198, 0)" }}/>}
                            </ListItem>
                            <Collapse  in={openAccounts} timeout="auto" unmountOnExit >
                                <List
                                    component="nav"
                                    aria-labelledby="nested-list-subheader"
                                >
                                    {
                                        (balances.length > 0) ? balances.map( (b, index) => {
                                            return <ListItem key = {b.Secuencial}>
                                                        {/* <ListItemAvatar>
                                                            <Avatar 
                                                                src = {`./../../../icons/${b.Tipo}.png`}
                                                            />
                                                        </ListItemAvatar> */}
                                                        <ListItemText
                                                            primary= {  <Typography className = {classes2.textaccounts} align = "left">
                                                                            {b.Tipo}
                                                                        </Typography>}
                                                            secondary={renderDetailSavingsAccount(b.SaldoCuenta, b.Codigo, b.EstadoNombre, b.Secuencial)}
                                                        />
                                                        {/* {(!isMobile) &&
                                                            <ListItemSecondaryAction>
                                                                <IconButton edge="end" aria-label="delete" onClick = {() => history.push(`/movements/${b.Secuencial}`)}>
                                                                    <img src={process.env.PUBLIC_URL + '/images/42.png'} alt="Logo" className={classes2.iconviewhistorial}  /> 
                                                                </IconButton>
                                                            </ListItemSecondaryAction>
                                                        } */}
                                                    </ListItem>
                                        }) :
                                        <ListItem>
                                            <ListItemText 
                                                primary = {<Typography className = {classes2.textaccounts} align = "center">
                                                                {"No tiene Cuentas de Ahorro disponibles"}
                                                            </Typography>}
                                            />
                                        </ListItem>
                                    }
                                </List>
                                
                            </Collapse>
                            <ListItem button onClick={() => setOpenAccountsJoint(!openAccountsJoint)}
                                            style={{    borderLeft: '3px solid rgba(255, 198, 0)',
                                                        color: '#009aa8', 
                                                        marginTop : "5px"
                                                    }}>
                                {/* {<ListItemIcon>
                                    <Icon>inbox</Icon>
                                </ListItemIcon>} */}
                                {/* <div className={classes2.icon} >
                                    <img src={'./../../../icons/CONJUNTAS.png'} alt="Logo" className={classes2.logo}  /> 
                                </div> */}
                                <ListItemText 
                                    primary={<Typography className = {classes2.textaccounts} align = "left">
                                                {"Cuenta conjunta"}
                                            </Typography>} 
                                    
                                />
                                {openAccountsJoint ? <ExpandLessIcon style={{ color: "rgba(255, 198, 0)" }}/> : <ExpandMoreIcon style={{ color: "rgba(255, 198, 0)" }}/>}
                            </ListItem>
                            <Collapse  in={openAccountsJoint} timeout="auto" unmountOnExit >
                                <List
                                    component="nav"
                                    aria-labelledby="nested-list-subheader"
                                >
                                    {
                                        (balancesjoint.length > 0) ? balancesjoint.map( (b, index) => {
                                            return <ListItem key = {b.Secuencial}>
                                                        {/* <ListItemAvatar>
                                                            <Avatar 
                                                                src = {`./../../../icons/${b.Tipo}.png`}
                                                            />
                                                        </ListItemAvatar> */}
                                                        <ListItemText
                                                            primary= {  <Typography className = {classes2.textaccounts} align = "left">
                                                                            {b.Tipo}
                                                                        </Typography>}
                                                            secondary={renderDetailSavingsAccount(b.SaldoCuenta, b.Codigo, b.EstadoNombre, b.Secuencial)}
                                                        />
                                                        {/* {(!isMobile) &&
                                                            <ListItemSecondaryAction>
                                                                <IconButton edge="end" aria-label="delete" onClick = {() => history.push(`/movements/${b.Secuencial}`)}>
                                                                    <img src={process.env.PUBLIC_URL + '/images/42.png'} alt="Logo" className={classes2.iconviewhistorial}  /> 
                                                                </IconButton>
                                                            </ListItemSecondaryAction>
                                                        } */}
                                                    </ListItem>
                                        }) :
                                        <ListItem>
                                            <ListItemText 
                                                primary = {<Typography className = {classes2.textaccounts} align = "center">
                                                                {"No tiene Cuentas Conjuntas disponibles"}
                                                            </Typography>}
                                            />
                                        </ListItem>
                                    }
                                </List>
                                
                            </Collapse>
                            <ListItem button
                                    onClick={() => setOpenDeposits(!openDeposits)}
                                    style={{ borderLeft: '3px solid rgba(255, 198, 0)',
                                            
                                    color: '#009aa8', marginTop : "5px"}}>
                                {/* {<ListItemIcon>
                                    <Icon>inbox</Icon>
                                </ListItemIcon>} */}
                                {/* <div className={classes2.icon} >
                                    <img src={'./../../../icons/19.png'} alt="Logo" className={classes2.logo}  /> 
                                </div> */}
                                <ListItemText 
                                    primary={<Typography className = {classes2.textaccounts} align = "left">
                                                {"Depósitos a plazo fijo"}
                                            </Typography>} 
                                    
                                />
                                {openDeposits ? <ExpandLessIcon style={{ color: "rgba(255, 198, 0)" }}/> : <ExpandMoreIcon style={{ color: "rgba(255, 198, 0)" }}/>}
                            </ListItem>
                            <Collapse  in={openDeposits} timeout="auto" unmountOnExit >
                                <List
                                    component="nav"
                                    aria-labelledby="nested-list-subheader"
                                >
                                    {
                                        (deposits.info.length > 0) ? deposits.info.map( (b, index) => {
                                            return <ListItem key = {b.Secuencial}>
                                                        {/* <ListItemAvatar>
                                                            <Avatar 
                                                                src = {`./../../../icons/19.png`}
                                                            />
                                                        </ListItemAvatar> */}
                                                        <ListItemText
                                                            primary= {  <Typography className = {classes2.textaccounts} align = "left">
                                                                            {b.TipoDeposito}
                                                                        </Typography>}
                                                            secondary={renderDetailFixedTermDeposits(b.Monto, b.Codigo, b.FechaVencimiento, b.Estado, b.Secuencial)}
                                                        />
                                                        {/* {(!isMobile) &&
                                                            <ListItemSecondaryAction>
                                                                <IconButton edge="end" aria-label="delete" onClick = {() => history.push(`/movements-deposits/${b.Secuencial}`)}>
                                                                    <img src={process.env.PUBLIC_URL + '/images/42.png'} alt="Logo" className={classes2.iconviewhistorial}  /> 
                                                                </IconButton>
                                                            </ListItemSecondaryAction>
                                                        } */}
                                                    </ListItem>
                                        }) :
                                        <ListItem>
                                            <ListItemText 
                                                primary = {<Typography className = {classes2.textaccounts} align = "center">
                                                                {"No tiene Depósitos a Plazo Fijo disponibles"}
                                                            </Typography>}
                                            />
                                        </ListItem>
                                    }
                                </List>
                            </Collapse>
                            <ListItem button onClick={() => setOpenCredits(!openCredits)}
                                        style={{ 
                                        borderLeft: '3px solid rgba(255, 198, 0)',
                                            
                                            color: '#009aa8', marginTop : "5px"}}>
                                {/* {<ListItemIcon>
                                    <Icon>inbox</Icon>
                                </ListItemIcon>} */}
                                {/* <div className={classes2.icon} >
                                    <img src={'./../../../icons/20.png'} alt="Logo" className={classes2.logo}  /> 
                                </div> */}
                                <ListItemText 
                                    primary={<Typography className = {classes2.textaccounts} align = "left">
                                                {"Créditos"}
                                            </Typography>} 
                                    
                                />
                                {openCredits ? <ExpandLessIcon style={{ color: "rgba(255, 198, 0)" }}/> : <ExpandMoreIcon style={{ color: "rgba(255, 198, 0)" }}/>}
                            </ListItem>
                            <Collapse  in={openCredits} timeout="auto" unmountOnExit >
                                <List
                                        component="nav"
                                        aria-labelledby="nested-list-subheader"
                                    >
                                    {
                                        (credits.infoPayment.length > 0) ? credits.infoPayment.map( (b, index) => {
                                            return <ListItem key = {b.Secuencial}>
                                                        {/* <ListItemAvatar>
                                                            <Avatar 
                                                                src = {`./../../../icons/credits.png`}
                                                            />
                                                        </ListItemAvatar> */}
                                                        <ListItemText
                                                            primary= {  <Typography className = {classes2.textaccounts} align = "left">
                                                                            {b.Tipo}
                                                                        </Typography>}
                                                            secondary={renderDetailCredits(b.Saldo, b.Codigo, b.Estado, b.Secuencial, b.DeudaInicial)}
                                                        />
                                                        {/* {(!isMobile) &&
                                                            <ListItemSecondaryAction>
                                                                <IconButton edge="end" aria-label="delete" onClick = {() => history.push(`/movements-credits/${b.Secuencial}`)}>
                                                                    <img src={process.env.PUBLIC_URL + '/images/42.png'} alt="Logo" className={classes2.iconviewhistorial}  /> 
                                                                </IconButton>
                                                            </ListItemSecondaryAction>
                                                        } */}
                                                    </ListItem>
                                        }) :
                                        <ListItem>
                                            <ListItemText 
                                                primary = {<Typography className = {classes2.textaccounts} align = "center">
                                                                {"No tiene Créditos disponibles"}
                                                            </Typography>}
                                            />
                                        </ListItem>
                                    }
                                </List>
                            </Collapse>
                        </List>
                    </Grid>
                </Grid>
        );
    }
};

UserInfo.propTypes = {
    customer: PropTypes.object.isRequired,
};

export default UserInfo;